const BASE = 8;

export default (...args: number[]) => args.map((value) => `${value * BASE}px`).join(' ');
